export const buildStorySlideGroups = (cards, isMobile) => {
  if (isMobile) {
    return cards.map((card) => [card]);
  }

  const hasSourceSlideIndexes = cards.every((card) => Number.isInteger(card.sourceSlideIndex));

  if (hasSourceSlideIndexes) {
    const groups = [];
    let sourceSlideIndex;
    let group;

    cards.forEach((card) => {
      if (card.sourceSlideIndex !== sourceSlideIndex) {
        sourceSlideIndex = card.sourceSlideIndex;
        group = [];
        groups.push(group);
      }

      group.push(card);
    });

    return groups;
  }

  const groups = [];
  let regularCards = [];

  cards.forEach((card) => {
    if (card.isBig) {
      if (regularCards.length) {
        groups.push(regularCards);
        regularCards = [];
      }

      groups.push([card]);
      return;
    }

    regularCards.push(card);

    if (regularCards.length === 2) {
      groups.push(regularCards);
      regularCards = [];
    }
  });

  if (regularCards.length) {
    groups.push(regularCards);
  }

  return groups;
};

export const shouldUseStoryRowLayout = (groups, isMobile) => !isMobile && groups.length === 1;
